export const environment = {
  production: true,
  customerType: "business",
  apiUrl: "https://akslsps-api.swsls.digital/api",
  assetsUrl: "https://akslsps-api.swsls.digital/assets",
  mock: false,
  mockContactData: false,
  mockBankingAccount: false,
  mockBillingAddress: false,
  mockPortingData: false,
  mockAddresses: false,
  mockBusinessData: false,
  mockContactPerson: false,
  mockBusinessBanking: false,
  mockBusinessPorting: false
}
